<template>
  <div>
    <service-quest-list
      :category="2"
      :param="{ status: 1 }"
      :canNew="true"
    ></service-quest-list>
  </div>
</template>

<script>
import ServiceQuestList from './list'

export default {
  components: { ServiceQuestList },
}
</script>